import { useContext } from 'react';

import { SignInContext } from '@modules/users';

import { isTrainingMockVisible, resolveTrainingConfig } from '../helpers';
import { TResolvedTraining } from '../types';

// Reads `organization.mock.training`, applies built-in defaults, and returns the
// resolved training record - or undefined when the training mock is not
// enabled/configured, so every surface can gate on a single call.
const useResolvedTraining = (): TResolvedTraining | undefined => {
  const { organization } = useContext(SignInContext);
  const config = organization.mock?.training;
  if (!config || !isTrainingMockVisible(config)) return undefined;
  return resolveTrainingConfig(config);
};

export default useResolvedTraining;
